// API
const PROD_CONSTANTS = {
  BASE_URL: 'https://convodo-d90f0.firebaseapp.com/',
  API_URL: 'https://us-central1-convodo-d90f0.cloudfunctions.net',
}
const DEV_CONSTANTS = {
  BASE_URL: 'http://localhost:3000',
  API_URL: 'http://localhost:5000/convodo-d90f0/us-central1',
}

const ENV_CONSTANTS = process.env.NODE_ENV === 'production' ? PROD_CONSTANTS : DEV_CONSTANTS;

export const BASE_URL = ENV_CONSTANTS.BASE_URL;
export const API_URL = ENV_CONSTANTS.API_URL;


// FRONT-END
export const CHAT = '/';
export const CONFIGURATION = '/configuration';
export const LOGIN = '/login';
export const SIGN_UP = '/sign_up';
